import { render, staticRenderFns } from "./CommonAreas.vue?vue&type=template&id=44033c58&scoped=true&"
import script from "./CommonAreas.vue?vue&type=script&lang=js&"
export * from "./CommonAreas.vue?vue&type=script&lang=js&"
import style0 from "./CommonAreas.vue?vue&type=style&index=0&id=44033c58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44033c58",
  null
  
)

export default component.exports